import { FC } from 'react';
import { Box, Text, Button, VStack } from '@chakra-ui/react';
import {
  DialogRoot,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  DialogTitle,
  DialogActionTrigger,
} from '@/components/ui/dialog';
import { AccountRecord } from '@/types/account';

interface DeleteAccountDialogProps {
  account: AccountRecord;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => Promise<void>;
  isDeleting: boolean;
}

/**
 * アカウント削除確認ダイアログコンポーネント
 * Authアカウントとユーザー情報を削除する。所有データ（個体・記録）は削除されず残る。
 */
export const DeleteAccountDialog: FC<DeleteAccountDialogProps> = ({
  account,
  open,
  onOpenChange,
  onDelete,
  isDeleting,
}) => {
  return (
    <DialogRoot open={open} onOpenChange={(e) => onOpenChange(e.open)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>アカウントの削除</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <VStack align="stretch" gap={4}>
            <Text fontWeight="medium">
              {account.userName}（{account.email}）を削除しますか？
            </Text>
            <Box p={3} bg="red.50" borderRadius="md" borderWidth={1} borderColor="red.200">
              <VStack align="stretch" gap={1}>
                <Text fontSize="sm" color="red.700">
                  ⚠ このアカウントではログインできなくなります。この操作は取り消せません。
                </Text>
                <Text fontSize="sm" color="red.700">
                  ⚠ 個体・繁殖記録などのデータは削除されず残ります。
                </Text>
              </VStack>
            </Box>
          </VStack>
        </DialogBody>
        <DialogFooter>
          <DialogActionTrigger asChild>
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              キャンセル
            </Button>
          </DialogActionTrigger>
          <Button colorPalette="red" onClick={onDelete} disabled={isDeleting}>
            {isDeleting ? '削除中...' : '削除する'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
